// CopyBlock.tsx — a titled card holding one copyable snippet (a command, a
// URL, a config block). Actionable, so header + body + footer with the Copy
// button in the footer; the result is inline status text, not a dialog.
import { useState } from 'react';
import Button from 'react-bootstrap/Button';
import Card from 'react-bootstrap/Card';
import { BsClipboard } from 'react-icons/bs';

export interface CopyBlockProps {
  title: string;
  text: string;
  caption?: string;
}

export function CopyBlock({ title, text, caption }: CopyBlockProps) {
  const [status, setStatus] = useState('');
  const copy = async () => {
    try {
      await navigator.clipboard.writeText(text);
      setStatus('Copied.');
    } catch {
      setStatus('Clipboard unavailable — select the text instead.');
    }
  };
  return (
    <Card>
      <Card.Header>{title}</Card.Header>
      <Card.Body>
        <pre className="mb-0 small" style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-all' }}>
          <code>{text}</code>
        </pre>
        {caption && <div className="small text-body-secondary mt-2">{caption}</div>}
      </Card.Body>
      <Card.Footer className="d-flex align-items-center gap-2">
        <Button size="sm" variant="outline-primary" onClick={() => void copy()}>
          <BsClipboard className="me-1" />
          Copy
        </Button>
        <span className="small text-body-secondary">{status}</span>
      </Card.Footer>
    </Card>
  );
}
